var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "32", height: "32", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("rect", { x: "11.319", y: "4.364", width: "17.028", height: "2.765", rx: "1.382", transform: "rotate(45 11.319 4.364)", fill: "#D1D1D1", stroke: "#D1D1D1", strokeWidth: ".9" }),
    React.createElement("rect", { x: "9.364", y: "26.68", width: "17.028", height: "2.765", rx: "1.382", transform: "rotate(-45 9.364 26.68)", fill: "#D1D1D1", stroke: "#D1D1D1", strokeWidth: ".9" })
  );
});